module.exports = __webpack_public_path__ + "img/softinya-6.53b2ed45.png";